import { Injectable } from '@angular/core';

@Injectable()
export class GlobalVar {

    public app_login:boolean = false;
    public app_user : any = {
        user_attribute : {},
        usergroup : []
    };

    constructor() { }

}



// WEBPACK FOOTER //
// ./src/providers/aproval_erp/globalvar/globalvar.ts